class ProductSnippet extends HTMLElement {
    constructor() {
        super();
        var main = this;
        this.productList = this.getAttribute('data-handle').split(",").map(function (value) {
            return value.trim();
        });

        this.productList.forEach(function (item, index) {
            main.createProduct(item);
        });
    }

    createProduct(handle) {
        fetch(`/products/${handle}.js`)
            .then(response => response.json())
            .then(data => {
                console.log(data);
                var product = `
                <div class="product_card">
                    <div class="">
                        <div class="">
                            <div class="">
                                <a href="${data.url}" class="block" aria-label="Link to CBD Oil">
                                    <img src="${data.media[1].src.replace(/\.png$/, '_300x.png')}" loading="lazy" class="card__image block rounded-media" width="${data.media[1].width}" height="${data.media[1].height}">
                                </a>
                            </div>
                        </div>
                    </div>
                    <div class="">
                        <div class="">
                            <h3 class="card__heading font-heading text-base leading-tight lg:text-xl mt-3 mb-1">
                                <a href="${data.url}" class="card__heading_link">
                                ${data.title}
                                </a>
                            </h3>
                        
                            <div class="">
                                <div class="price  flex items-center text-base lg:text-lg mb-2"> 
                                    <div class="price__container">
                                        <div class="price__regular">
                                            <span class="visually-hidden visually-hidden--inline">Regular price</span>
                                            <span class="price-item price-item--regular">
                                                ${data.variants != null ? `From $${(data.price / 100)}` : `$${(data.price / 100)}`}
                                            </span>
                                        </div>
                                        <small class="unit-price caption hidden">
                                            <span class="visually-hidden">Unit price</span>
                                            <span class="price-item price-item--last">
                                                <span></span>
                                                <span aria-hidden="true">/</span>
                                                <span class="visually-hidden">&nbsp;per&nbsp;</span>
                                                <span>
                                                </span>
                                            </span>
                                        </small>
                                    </div>
                                </div>

                                <a href="${data.url}" class="card__heading_link cursor-pointer inline-flex px-4 lg:px-5 py-1.5 lg:py-2 bg-accent-1 hover:bg-[#222] text-white font-medium text-sm lg:text-base leading-snug uppercase rounded-button focus:shadow-lg focus:outline-none focus:ring-0 font-heading transition duration-150 ease mb-2">
                                    Shop Now 
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
              `;

                this.innerHTML += product;
            });

    }
}

customElements.define('product-snippet', ProductSnippet);

class VariantSnippet extends HTMLElement {
    constructor() {
        super();

        this.product = this.getAttribute('data-handle').trim();
        this.variantList = this.getAttribute('data-variant').split(",").map(function (value) {
            return value.trim();
        });
        this.createProduct(this.product);

        console.log(this.variantList);
    }

    createProduct(handle) {
        var main = this;
        fetch(`/products/${handle}.js`)
            .then(response => response.json())
            .then(data => {
                console.log(data);
                data.variants.map((item, idx) => {
                    if (this.variantList.includes(item.title)) {
                        var product = `
                        <div class="product_card">
                            <div class="">
                                <div class="">
                                    <div class="">
                                        <a href="${data.url}" class="block" aria-label="Link to CBD Oil">
                                            <img src="${item.featured_media.preview_image.src.replace(/\.png$/, '_300x.png')}" loading="lazy" class="card__image block rounded-media" width="${item.featured_media.preview_image.width}" height="${item.featured_media.preview_image.height}">
                                        </a>
                                    </div>
                                </div>
                            </div>
                            <div class="">
                                <div class="">
                                    <h3 class="card__heading font-heading text-base leading-tight lg:text-xl mt-3 mb-1">
                                        <a href="${item.url}" class="card__heading_link">
                                        ${item.title}
                                        </a>
                                    </h3>
                                
                                    <div class="">
                                        <div class="price  flex items-center text-base lg:text-lg mb-2"> 
                                            <div class="price__container">
                                                <div class="price__regular">
                                                    <span class="visually-hidden visually-hidden--inline">Regular price</span>
                                                    <span class="price-item price-item--regular">
                                                    $${(item.price / 100)}
                                                    </span>
                                                </div>
                                                <small class="unit-price caption hidden">
                                                    <span class="visually-hidden">Unit price</span>
                                                    <span class="price-item price-item--last">
                                                        <span></span>
                                                        <span aria-hidden="true">/</span>
                                                        <span class="visually-hidden">&nbsp;per&nbsp;</span>
                                                        <span>
                                                        </span>
                                                    </span>
                                                </small>
                                            </div>
                                        </div>

                                        <a href="${item.url}" class="card__heading_link cursor-pointer inline-flex px-4 lg:px-5 py-1.5 lg:py-2 bg-accent-1 hover:bg-[#222] text-white font-medium text-sm lg:text-base leading-snug uppercase rounded-button focus:shadow-lg focus:outline-none focus:ring-0 font-heading transition duration-150 ease mb-2">
                                            Shop Now 
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    `;

                        main.innerHTML += product;
                    }
                });

            });

    }
}

customElements.define('variant-snippet', VariantSnippet);
